export default {
  'formula.title': '配方管理',

  'formula.guideline': '指引',
  'formula.guideline.tips': '配方将打印在杯贴上，以指导门店员工制作出品；或转换为二维码，由自动茶饮机识别。',
  'formula.guideline.step.customizations-combination': '附加选项方案',
  'formula.guideline.step.customizations-combination.tips':
    '请为每一个选项设定代码，并设定选项组之间的顺序，以便在制作时知晓顾客选择的杯型、糖度、温度等。',
  'formula.guideline.step.item-code-association': '菜品代码和关联',
  'formula.guideline.step.item-code-association.tips':
    '设定菜品代码，以便自动设备识别；为菜品关联附加选项方案，该方案将以代码或二维码方式，打印在杯贴上。',
  'formula.guideline.step.print-settings': '打印设置',
  'formula.guideline.step.print-settings.tips':
    '设置在杯贴上打印的内容，可选择以代码方式打印配方，或以二维码方式打印配方。',
  'formula.guideline.step.setting': '前往设置',

  'formula.customizations-combination': '附加选项方案',
  'formula.customizations-combination.table.search.placeholder': '按方案名称搜索',
  'formula.customizations-combination.table.column.combination-name': '方案名称',
  'formula.customizations-combination.table.column.customizations-combination': '附加选项组合',
  'formula.customizations-combination.table.column.associated-items': '关联菜品数量',
  'formula.customizations-combination.table.column.action': '操作',
  'formula.customizations-combination.table.column.delete.title': '确认删除此方案？',
  'formula.customizations-combination.form.title.create': '创建附加选项方案',
  'formula.customizations-combination.form.title.edit': '编辑附加选项方案',
  'formula.customizations-combination.form.card.tips':
    '选择附加选项，为每个选项设置代码，调整选项组之间的顺序。同一个选项的代码，在不同方案中是一致的。',
  'formula.customizations-combination.form.section.combination-name': '附加选项方案名称',
  'formula.customizations-combination.form.field.combination-name.placeholder': '请输入方案名称',
  'formula.customizations-combination.form.field.combination-name.tips': '方案名称不会展示给用户，仅作为管理之用',
  'formula.customizations-combination.form.section.customizations-combination': '附加选项组合',
  'formula.customizations-combination.form.select-customizations.button.sort': '排序',
  'formula.customizations-combination.form.select-customizations.button.modify-customizations': '修改附加选项',
  'formula.customizations-combination.form.select-customizations.button.select-customizations': '选择附加选项',
  'formula.customizations-combination.form.select-customizations.tips':
    '同一选项的代码，在不同方案中是一致的，会同步更新，请谨慎修改',
  'formula.customizations-combination.form.select-customizations.modal.select.title': '选择附加选项',
  'formula.customizations-combination.form.select-customizations.modal.search.placeholder': '搜索附加选项组',
  'formula.customizations-combination.form.select-customizations.modal.sort.title': '设置排序',
  'formula.customizations-combination.form.select-customizations.table.column.customization-groups': '附加选项组',
  'formula.customizations-combination.form.select-customizations.table.column.customizations': '附加选项',
  'formula.customizations-combination.form.select-customizations.table.column.customization-code': '附加选项代码',
  'formula.customizations-combination.form.select-customizations.table.column.customization-code.placeholder':
    '请输入附加选项代码',
  'formula.customizations-combination.form.select-customizations.require': '请选择附加选项',

  'formula.item-code-association': '菜品代码和关联',
  'formula.item-code-association.meals.empty': '暂无数据',
  'formula.item-code-association.meals.action.associate': '关联',
  'formula.item-code-association.meals.action.alter': '修改关联',
  'formula.item-code-association.meals.action.disassociate': '取消关联',
  'formula.item-code-association.meals.action.batch-association': '批量关联',
  'formula.item-code-association.meals.action.batch-association.warning': '部分菜品暂不能关联附加选项方案',
  'formula.item-code-association.meals.action.batch-association.warning.description':
    '请先在菜品编辑器中设置菜品的附加选项',
  'formula.item-code-association.meals.action.batch-association.warning.continue': '继续关联',
  'formula.item-code-association.meals.action.batch-association.warning.back-to-modify': '返回修改',
  'formula.item-code-association.meals.item.item-code': '菜品代码',
  'formula.item-code-association.meals.item.item-code.placeholder': '请输入菜品代码',
  'formula.item-code-association.meals.item.customizations-combination': '附加选项方案',
  'formula.item-code-association.meals.modal.association.title.meal': '选择要关联的菜品',
  'formula.item-code-association.meals.modal.association.title.customization': '关联附加选项方案',
  'formula.item-code-association.meals.modal.association.select-all': '全选',
  'formula.item-code-association.meals.modal.association.select-tips': '已选择 {sum} 个菜品',
  'formula.item-code-association.meals.save.warning': '部分菜品尚未设置代码或配方',
  'formula.item-code-association.meals.save.warning.description': '是否立即保存？',
  'formula.item-code-association.meals.save.warning.save-immediately': '立即保存',
  'formula.item-code-association.meals.save.warning.back-to-modify': '返回修改',
};
